import React from 'react'

export const Buttom = ({onClick}) => {
    return (
        <div>
           <input type="button" onClick={onClick} value="Cambiar a Fareheit"/>
        </div>
    )
}
